import { MONDELEZ_LEVEL_COLORS } from '@/constants/mondelez.constants.js'

export default function useMondelez() {
  const getMondelezLevelColor = (result) => {
    const colors = MONDELEZ_LEVEL_COLORS

    if (result <= 1) return colors.green
    if (result <= 2) return colors.green
    if (result <= 4) return colors.lighYellow
    if (result <= 6) return colors.yellow
    if (result >= 9) return colors.red

    return null
  }

  return {
    getMondelezLevelColor,
  }
}
